export function getFileSize(sizeInBytes: number) {
	const units = ["Bytes", "KB", "MB"];
	let index = 0;
	let fileSize = sizeInBytes;

	if (sizeInBytes < 1024) {
		fileSize = Number(fileSize);
	}

	while (fileSize >= 1024 && index < units.length - 1) {
		fileSize /= 1024;
		index += 1;
	}

	const formattedSize = fileSize?.toFixed(2);
	const unit = units[index];

	return `${formattedSize?.replace(/\.00$/, "")} ${unit}`;
}
